// extracted by mini-css-extract-plugin
export default {"activityInfos":"ActivityInfos_activityInfos__ONzXW"};